(function () {
  var popup = document.querySelector('.presale_popup');
  if (!popup) return;

  var dialog = popup.querySelector('[role="dialog"]');
  var confirmBtn = popup.querySelector('.close_msg');
  var closeBtn = popup.querySelector('.presale_popup__close');
  var lastOpener = null;

  function openPresalePopup(opener) {
    lastOpener = opener || null;
    popup.classList.add('active');
    popup.removeAttribute('hidden');
    popup.setAttribute('aria-hidden', 'false');
    document.body.classList.add('overflow-hidden');

    var focusTarget = confirmBtn || closeBtn || dialog;
    if (typeof trapFocus === 'function' && dialog) {
      trapFocus(popup, focusTarget);
    } else if (focusTarget && typeof focusTarget.focus === 'function') {
      focusTarget.focus();
    }
  }

  function closePresalePopup() {
    popup.classList.remove('active');
    popup.setAttribute('hidden', '');
    popup.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('overflow-hidden');

    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus(lastOpener);
    } else if (lastOpener && typeof lastOpener.focus === 'function') {
      lastOpener.focus();
    }

    lastOpener = null;
  }

  function bindOpener(selector) {
    document.querySelectorAll(selector).forEach(function (el) {
      el.addEventListener('click', function (event) {
        openPresalePopup(event.currentTarget);
      });
    });
  }

  bindOpener('#notify');
  bindOpener('#AddOnButton');

  document.addEventListener('click', function (event) {
    if (event.target.id === 'ProductSubmitButton-footer') {
      openPresalePopup(event.target);
    }
  });

  if (confirmBtn) {
    confirmBtn.addEventListener('click', function (event) {
      event.stopPropagation();
      closePresalePopup();
    });
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', function (event) {
      event.stopPropagation();
      closePresalePopup();
    });
  }

  popup.addEventListener('click', function (event) {
    if (event.target === popup) {
      closePresalePopup();
    }
  });

  if (dialog) {
    dialog.addEventListener('click', function (event) {
      event.stopPropagation();
    });
  }

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' || !popup.classList.contains('active')) return;
    event.preventDefault();
    closePresalePopup();
  });
})();
